<template>
  <v-navigation-drawer temporary left app v-model="curVisible" color="#f2f2f2" class="us-v-navigation" clipped>
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar style="border-radius:0.3rem;">
            <img :src="userInfo.headimgurl">
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{userInfo.nickname}}</v-list-item-title>
            <!-- <v-list-item-subtitle style="color:#4CAF50;padding-top:0.1rem;">已登录</v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>
      </template>

      <ToggleCompany @toggled="companyToggled" v-if="curVisible" />

      <v-divider></v-divider>

      <v-list style="padding-top:1rem;">
        <v-list-item v-for="item in items" :key="item.title" @click="goPage(item)" style="padding-left:1.3rem;">
          <v-list-item-icon style="width:2rem;text-align:center;margin-right:1.3rem;">
            <v-icon style="margin:auto;" :style="{ fontSize: item.iconSize}">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
            <i class="fa fa-angle-right" aria-hidden="true" style="font-size:1.6rem;color:#808080;position:absolute;right:1.2rem;pointer-events:none;top:1rem;" ></i>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list-item style="padding-left:1.3rem;">
          <v-list-item-icon style="width:2rem;text-align:center;margin-right:1.3rem;">
            <!-- <i style="margin:auto;font-size: 1.9rem" class="el-icon-s-opportunity"> -->
              <v-icon style="margin:auto;font-size: 1.9rem" class="">mdi-minus-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ versions }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      <!-- <template v-slot:append>
        <div class="pa-2">
          <v-btn block>退出登录</v-btn>
        </div>
      </template> -->

    </v-navigation-drawer>
</template>
<script>
// import store from '../stores/index'
import ToggleCompany from '../views/Biz/Company/ToggleCompany'
export default {
  components: {
    ToggleCompany
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    curVisible: {
      get() {
        return this.visible
      },
      set(val) {
        var that = this
        that.$emit('update:visible', val)
        if (!val) {
          that.$emit('closed')
        }
      }
    },
    versions: {
      get() {
        return this.getVer()
      },
      set(val) {
        var that = this
        that.versions = val
      }
    }
  },
  watch: {
    visible() {
      var that = this
      that.userInfo = that.$AppHelper.getUserInfo()
    }
  },
  data: () => ({
    items: [
      // { title: '我的', icon: 'fa fa-user-circle', link: '/UserProfile' },
      // { title: '报障工单', icon: 'fa fa-th-list', link: '/OrderList' },
      // { title: '报障参与', icon: 'fa fa-th-list', link: '/ShareOrderList' },
      // { title: '报障统计', icon: 'fa fa-bar-chart', link: '/OrderStat' },
      // { title: '设备列表', icon: 'fa fa-desktop', link: '/DeviceList' },
      { title: '团员列表', icon: 'mdi-account-supervisor-circle', link: '/StaffList', iconSize: '1.9rem', verify: true }
      // { title: '测试页面', icon: 'fa fa-wrench', link: '/DubugTest' }
    ],
    userInfo: {},
    customData: {}
  }),
  methods: {
    goPage(item) {
      var that = this
      if (!item.link) {
        that.$toast('页面未完成');
        return
      }
      // if (item.verify) {
      //   if (!that.verifyCompanyAdmin()) {
      //     that.$toast.warning('您的权限不足');
      //     return
      //   }
      // }
      that.curVisible = false;
      // that.$router.push(item.link)
      that.$router.goPage({ path: item.link })
    },
    verifyCompanyAdmin() {
      var that = this
      var staffInfo = that.$AppHelper.getCustomData('staff_info');
      if (staffInfo && staffInfo.STAFF_ROLE === 'admin') {
        return true;
      }
      return false
    },
    companyToggled(code) {
      var that = this
      that.curVisible = false
      that.$emit('company-toggled', code)
    },
    getVer() {
      var that = this
      var ver = '未知版'
      if (that.userInfo) {
        const vers = that.userInfo.gzh_ver
        if (vers === 'v1') {
          ver = '稳定版 2.0'
        } else if (vers === 'v2') {
          ver = '开发版公测 2.1'
        } else if (vers === 'v3') {
          ver = '开发版 2.2'
        }
      }
      return ver
    }
  },
  mounted() {
    var that = this
    that.userInfo = that.$AppHelper.getUserInfo()
    that.customData = that.$AppHelper.getCustomData();
  },
  activated() {

  }
}
</script>

<style scoped>

.us-v-navigation >>> .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    /* color: rgba(255, 255, 255, 0.87) !important; */
}

</style>
